import { delayRepayRoute } from './helpers';
import { DelayRepayPages } from '../../../../src/constants/AppConstants';

export default delayRepayRoute(DelayRepayPages.CONFIRM, {
    getComponent(location, cb) {
        require.ensure([], (require) => {
            cb(null, require('../../components/delayRepay/Confirm').default);
        }, 'delayrepay-confirm');
    }
});
